import { Controller } from "@hotwired/stimulus"
import { patch, destroy } from "@rails/request.js"

export default class extends Controller {
  static targets = ["content", "editForm", "input", "emojiPicker", "deleteButton"]
  static values = { cardId: String }

  edit(event) {
    event.preventDefault()
    event.stopPropagation()

    const rawContent = this.contentTarget.dataset.rawContent || ""
    this.inputTarget.value = rawContent

    this.contentTarget.classList.add("hidden")
    this.editFormTarget.classList.remove("hidden")
    if (this.hasDeleteButtonTarget) this.deleteButtonTarget.classList.add("hidden")
    this.inputTarget.focus()
    this.inputTarget.setSelectionRange(rawContent.length, rawContent.length)
  }

  cancel() {
    this.editFormTarget.classList.add("hidden")
    this.contentTarget.classList.remove("hidden")
    if (this.hasDeleteButtonTarget) this.deleteButtonTarget.classList.remove("hidden")
  }

  async save(event) {
    // Don't save on blur if user clicked an emoji button
    if (event.type === "blur") {
      const relatedTarget = event.relatedTarget
      if (relatedTarget && relatedTarget.closest("[data-journey-map-card-target='emojiPicker']")) {
        return
      }
    }

    const content = this.inputTarget.value.trim()

    if (!content) {
      this.cancel()
      return
    }

    try {
      const response = await patch(`/workspace/journey_map_cards/${this.cardIdValue}`, {
        body: JSON.stringify({
          journey_map_card: { content: content }
        }),
        contentType: "application/json",
        responseKind: "json"
      })

      if (response.ok) {
        const data = await response.json
        this.contentTarget.innerHTML = data.rendered_content
        this.contentTarget.dataset.rawContent = content
      }
    } catch (error) {
      console.error("Error saving card:", error)
    }

    this.cancel()
  }

  selectEmoji(event) {
    event.preventDefault()
    event.stopPropagation()

    const emoji = event.currentTarget.dataset.emoji

    // Highlight selected emoji
    if (this.hasEmojiPickerTarget) {
      this.emojiPickerTarget.querySelectorAll("button").forEach(btn => {
        btn.classList.remove("bg-brand/20", "ring-1", "ring-brand")
      })
      event.currentTarget.classList.add("bg-brand/20", "ring-1", "ring-brand")
    }

    // Save emoji immediately
    this.saveEmoji(emoji)
    this.inputTarget.focus()
  }

  async saveEmoji(emoji) {
    try {
      await patch(`/workspace/journey_map_cards/${this.cardIdValue}`, {
        body: JSON.stringify({
          journey_map_card: { emoji: emoji }
        }),
        contentType: "application/json",
        responseKind: "json"
      })
    } catch (error) {
      console.error("Error saving emoji:", error)
    }
  }

  async destroy(event) {
    event.preventDefault()
    event.stopPropagation()

    if (!confirm("Remove this card?")) return

    try {
      const response = await destroy(`/workspace/journey_map_cards/${this.cardIdValue}`, {
        responseKind: "json"
      })

      if (response.ok) {
        this.element.remove()
      }
    } catch (error) {
      console.error("Error deleting card:", error)
    }
  }

  handleKeydown(event) {
    if (event.key === "Enter" && !event.shiftKey) {
      event.preventDefault()
      this.save(event)
    }
    if (event.key === "Escape") {
      this.cancel()
    }
  }
}
